import { fontFamily } from './font-family';
import { fontWeights } from './font-weights';
import { pxToRem } from '@/@mui/utils/px-to-rem';

export const typography = {
  h1: {
    fontSize: pxToRem(24),
    fontWeight: fontWeights.fontWeightSemibold,
    fontFamily: fontFamily.fontFamilyCarbona,
  },
  h2: {
    fontSize: pxToRem(18),
    fontWeight: fontWeights.fontWeightSemibold,
    fontFamily: fontFamily.fontFamilyCarbona,
  },
  h3: {
    fontSize: pxToRem(15),
    fontWeight: fontWeights.fontWeightSemibold,
    fontFamily: fontFamily.fontFamilyCarbona,
    lineHeight: pxToRem(20),
  },
  h4: {
    fontSize: pxToRem(14.5),
    fontWeight: fontWeights.fontWeightSemibold,
    fontFamily: fontFamily.fontFamilyCarbona,
    lineHeight: pxToRem(20),
  },
  body1: {
    fontSize: pxToRem(15),
    fontWeight: fontWeights.fontWeightRegular,
    fontFamily: fontFamily.fontFamilyAssistant,
  },
  body2: {
    fontSize: pxToRem(13),
    lineHeight: pxToRem(20),
    fontWeight: fontWeights.fontWeightRegular,
    fontFamily: fontFamily.fontFamilyAssistant,
  },
  ...fontWeights,
};
